import React, { Suspense } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "lib/queryClient";
import { ErrorBoundary } from "components/ErrorBoundary";
import { PermissionsProvider } from "hooks";
import { LicenseStatusProvider } from "contexts/LicenseStatusContext";
import { PackagesProvider } from "contexts/PackagesContext";
import { GlobalLoadingWrapper, ToastContainer } from "components/ui";
import { Spinner } from "components/ui";

export const AppPageFallback: React.FC = () => (
  <div className="flex min-h-[40vh] items-center justify-center">
    <Spinner size="lg" />
  </div>
);

type AppProvidersProps = {
  children: React.ReactNode;
};

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => (
  <QueryClientProvider client={queryClient}>
    <ErrorBoundary>
      <PermissionsProvider>
        <LicenseStatusProvider>
          <PackagesProvider>
            <GlobalLoadingWrapper>
              <ToastContainer />
              <Suspense fallback={<AppPageFallback />}>{children}</Suspense>
            </GlobalLoadingWrapper>
          </PackagesProvider>
        </LicenseStatusProvider>
      </PermissionsProvider>
    </ErrorBoundary>
  </QueryClientProvider>
);
